import {type ServerError} from '@logistics-frontend/core/utils/network'
import {type PaymentCard, formatCardNumber} from '@yandex-delivery/api/model/payment'
import {useTransition} from '@yandex-delivery/blocks'
import {useController, useFormContext} from '@yandex-delivery/form'
import {type Optional} from '@yandex-delivery/types'

import {i18n} from 'src/shared/config'
import type {Order} from 'src/shared/types'

import {CardErrorCode, fetchCard} from './api'
import {type Props} from './types'
import {getIconSrc} from './utils'

export function useCard({name, getBody: getBodyProp}: Props) {
  const {control, getFieldValue} = useFormContext<Order>()
  const {field, fieldState} = useController({
    // @ts-expect-error проблемы типизации RHF
    name,
    control,
  })
  const card: Optional<PaymentCard> = field.value
  const title = card ? formatCardNumber(card) : i18n('profile.payment-card', 'Карта')

  function changeHandler(nextCard: PaymentCard) {
    if (card && card.id === nextCard.id) {
      return
    }

    field.onChange(nextCard)
  }

  const [{isPending, error}] = useTransition<Optional<PaymentCard>, ServerError>(
    () => fetchCard({onSuccess: changeHandler}),
    {key: `fetch/order-form/cards/${name}`},
  )

  return {
    unauthorized: error?.message === CardErrorCode.UNAUTHORIZED || error?.status === 401 ? error.message : undefined,
    errorText: fieldState.invalid
      ? i18n('order.form.error.empty-payment-card', 'Выберите карту для оплаты')
      : undefined,
    isPending,
    title,
    iconSrc: getIconSrc(card?.system),
    card,
    getBody() {
      return getBodyProp(getFieldValue())
    },
    changeHandler,
  } as const
}
